<template>
  <div>
    <v-form ref="formEndossoCancelamento" lazy-validation @submit.prevent="mostarModarConfirma()">
      <h2 class="title mb-4">Endosso de Cancelamento</h2>

      <v-layout row wrap>
        <v-flex md4 sm12>
          <v-text-field
            :value="maskCnpj(proposta.tomador.cnpj_cpf)"
            class="jns-input"
            label="CNPJ"
            disabled
            v-mask="['##.###.###/####-##']"
            placeholder=" "
          ></v-text-field>
        </v-flex>

        <v-flex md8 sm12>
          <v-text-field
            v-model="proposta.tomador.nome"
            class="jns-input"
            label="Razão Social"
            disabled
            placeholder=" "
          ></v-text-field>
        </v-flex>

        <v-flex md4 sm12>
          <v-text-field
            :value="proposta.id_apolice"
            class="jns-input"
            label="Apólice"
            disabled
            placeholder=" "
          ></v-text-field>
        </v-flex>

        <v-flex md8 sm12>
          <v-text-field
            :value="proposta.coberturas[0].importancia_segurada.toLocaleString('pt-BR', $settings.moneyFormatOptions)"
            class="jns-input"
            label="Importância Segurada"
            disabled
            placeholder=" "
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-select
            v-model="motivo"
            :rules="[rules.obrigatorio]"
            :items="motivos"
            :item-text="'descricao'"
            label="Motivo de cancelamento"
            class="form-select-box"
            placeholder="Selecionar"
            no-data-text="Carregando ..."
            return-object
          ></v-select>
        </v-flex>

        <v-flex xs12 v-if="motivo && motivo.reemissao && motivo.automatico">
          <v-select
            v-model="propostaReemitida"
            :rules="[rules.obrigatorio]"
            :items="propostasEmitidas"
            :item-text="'id_apolice'"
            label="Apólice"
            class="form-select-box"
            placeholder="Selecionar"
            no-data-text="Nenhuma apólice encontrada"
            return-object
          ></v-select>
        </v-flex>

        <v-flex xs12>
          <v-textarea
            class="jns-input"
            v-model="item.observacao"
            placeholder=" "
            label="Observação"
            :rules="[rules.obrigatorio]"
          ></v-textarea>
        </v-flex>

        <v-flex md4 sm6>
          <button
            class="button jns-button white-button"
            type="reset"
            @click="$emit('fechar')"
          >Fechar</button>
        </v-flex>

        <v-flex md4 offset-md4 sm6>
          <button class="button jns-button yellow-button" type="submit">Solicitar Cancelamento</button>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog max-width="600" v-model="showMensageDialog">
      <base-modal>
        <h3 class="mb-3">{{dialogMessage.message}}</h3>

        <v-layout row wrap>
          <v-flex md4 sm6 v-if="dialogMessage.modalConfirma">
            <button class="button jns-button white-button" @click="$emit('fechar')">Desistir</button>
          </v-flex>

          <v-flex
            md4
            :class="dialogMessage.modalConfirma ? 'offset-md4 sm6' : 'offset-md8 sm6 offset-sm6'"
          >
            <button
              class="button jns-button yellow-button"
              @click="dialogMessage.callback()"
            >{{dialogMessage.modalConfirma ? 'Confirmar' : 'Fechar'}}</button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <!-- Modal termos de aceite para emitir proposta -->
    <v-form ref="formTermosAceite" lazy-validation>
      <v-dialog
        v-model="showAceiteEndossoCancelamentoDialog"
        scrollable
        persistent
        max-height="600px"
        min-height="500px"
        max-width="800px"
      >
        <v-card class="px-3 pt-3">
          <v-card-text>
            <h2 class="headline">Termo de Aceite</h2>
            <div class="pt-2 pb-4">
              <span>Leia os termos para solicitar o endosso de cancelamento.</span>
            </div>
            <p>{{ termos }}</p>
          </v-card-text>

          <v-card-actions>
            <v-checkbox
              v-if="showAceiteEndossoCancelamentoDialog"
              label="Declaro que li e estou de acordo com os termos acima"
              :rules="[rules.obrigatorio]"
            ></v-checkbox>

            <v-layout row wrap>
              <v-flex xs6>
                <button
                  style="width: 130px;"
                  class="jns-button width-auto white-button"
                  outline
                  round
                  type="button"
                  @click="showAceiteEndossoCancelamentoDialog = false"
                >Cancelar</button>
              </v-flex>

              <v-flex xs6>
                <button
                  style="width: 150px;"
                  class="jns-button width-auto yellow-button"
                  round
                  @click.prevent="solicitarCancelamento()"
                >Solicitar</button>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- ./Modal termos de aceite para emitir proposta -->
  </div>
</template>

<script lang="js">
import { maskCnpj } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "EndossoCancelamentoComponent",
  mixins: [ViewMixin],
  data() {
    return {
      maskCnpj,
      showAceiteEndossoCancelamentoDialog: false,
      showMensageDialog: false,
      dialogMessage: {},
      item: {},
      motivo: null,
      propostaReemitida: null,
      motivos: [],
      propostasEmitidas: [],
      rules: {
        obrigatorio: (v) => !!v || "Campo obrigatório",
      },
      termos: `As informações fornecidas para o exame do cancelamento Apólice de Seguros, através deste portal, representam os elementos necessários para a análise por parte da Seguradora, bem como, são verdadeiros.
               O Tomador, por meio próprio ou por seu Corretor de Seguros, declara ainda, expressamente, ter lido, compreendido e que está de acordo com as condições aqui estabelecidas.`,
    };
  },
  props: ["proposta"],
  methods: {
    async getMotivos() {
      try {
        this.motivos = await this.$store.dispatch("GET_MOTIVOS_CANCELAMENTO");
      } catch (e) {
        this.setErrorModal(e.response.data);
      }
    },

    async getPropostasEmitidasPorTomador() {
      if (!this.propostasEmitidas || !this.propostasEmitidas.length)
        try {
          this.showLoadingAskWait();
          // let dataFim = new Date(this.proposta.data_emissao).setDate(0);
          // dataFim.setDate(dataFim.getDate() + 2);

          this.propostasEmitidas = await this.$store.dispatch("GET_PROPOSALS", {
            filtros: {
              status: this.proposta.status,
              tomador_documento: this.proposta.tomador.cnpj_cpf,
              data_emissao__gte: this.proposta.data_emissao,
              // data_inicio: this.proposta.data_emissao,
              // data_fim: dataFim.toISOString().slice(0, 10),
            },
          });
        } catch (e) {
          this.setErrorModal(e.response.data);
        } finally {
          this.hideLoadingAskWait();
        }

      let propostaIndexOf = this.propostasEmitidas.indexOf(
        this.propostasEmitidas.filter((item) => {
          return item.id == this.proposta.id;
        })[0]
      );
      if (propostaIndexOf >= 0)
        this.propostasEmitidas.splice(propostaIndexOf, 1);

      if (!this.propostasEmitidas || !this.propostasEmitidas.length) {
        this.mostrarModalErro();
        this.propostasEmitidas = [];
      }
    },

    async solicitarCancelamento() {
      var t = this;
      if (this.$refs.formTermosAceite.validate()) {
        try {
          this.showAceiteEndossoCancelamentoDialog = false;
          this.showLoadingIndicator();
          await this.$store.dispatch("POST_CANCELAMENTO", this.item);
          this.mostrarModalSucesso();
        } catch (e) {
          this.setErrorModal(e.response.data);
        } finally {
          this.hideLoadingIndicator();
        }
      }
    },

    mostrarModalSucesso() {
      this.showMensageDialog = true;
      this.dialogMessage = {
        message: "Cancelamento efetivado com sucesso!",
        callback: this.fecharModal,
        modalConfirma: false,
      };
      this.$forceUpdate();
    },

    mostarModarConfirma() {
      this.showMensageDialog = true;
      this.modalConfirma = true;
      this.dialogMessage = {
        message: "Tem certeza que deseja cancelar essa apólice?",
        callback: this.abrirModalAceite,
        modalConfirma: true,
      };
      this.$forceUpdate();
    },

    fecharModal() {
      window.location.reload();
    },
    mostrarModalErro() {
      var option = {
        title: "Não encontramos nenhuma apólice vigente para o mesmo tomador",
        message:
          "Favor entrar em contato com nosso time Comercial para realizar a solicitação",
      };
      this.setErrorModal(option);
    },

    goToMesa() {
      this.$router.push({ name: "Mesa de Trabalho" });
    },

    abrirModalAceite() {
      this.showMensageDialog = false;
      this.showAceiteEndossoCancelamentoDialog = true;
    },
  },
  created() {
    this.getMotivos();
    this.propostasEmitidas = [];
  },
  watch: {
    motivo: function (newValue) {
      this.item.id_motivo = newValue.id;
      if (newValue.reemissao) this.getPropostasEmitidasPorTomador();
    },

    propostaReemitida: function (newValue) {
      this.item.proposta_reemitida = {
        id_proposta: newValue.id,
        id_produto: newValue.id_produto,
      };
    },
  },
  mounted() {
    this.item = {
      id_proposta: this.proposta.id,
      id_apolice: this.proposta.id_apolice,
      id_produto: this.proposta.id_produto,
    };
  },
};
</script>

<style lang="scss" scoped>
.titulo {
  font-size: 2vh !important;
}
</style>



// WEBPACK FOOTER //
// ./src/components/EndossoCancelamentoComponent.vue